import React, { useState } from 'react';
import { Box, Flex, VStack, Link, Icon, Collapse, Text } from '@chakra-ui/react';
import { FaHome, FaBriefcase, FaHistory, FaUser, FaCog, FaQuestionCircle, FaFileAlt, FaLock, FaCalendar, FaChartLine } from 'react-icons/fa';
import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';

const Sidebar = ({ onSelectItem, selectedItem, onSelectProfileSubView }) => {
  const [isProfileOpen, setIsProfileOpen] = useState(false);

  const toggleProfile = () => {
    setIsProfileOpen(!isProfileOpen);
    onSelectItem('profile');
    onSelectProfileSubView('personalInfo');
  };

  const handleSelectItem = (item) => {
    if (item !== 'profile') {
      setIsProfileOpen(false); // Close profile submenu when another item is selected
    }
    onSelectItem(item);
  };

  return (
    <Flex
      direction="column"
      bg="white"
      shadow="lg"
      justify="space-between"
      w="100vw"
      h="100vh"
    >
      <VStack spacing={4} align="flex-start" p={4}>
        <Box fontWeight="bold" fontSize="xl" mb={6} h="40px" display="flex" alignItems="center">
          <Text>CUROLYN</Text>
        </Box>

        <Flex direction="column" as="nav" w="full">
          <Link
            p={2}
            h="40px"
            href="#"
            display="flex"
            alignItems="center"
            justifyContent="flex-start"
            w="full"
            bg={selectedItem === 'home' ? 'blue.500' : 'transparent'}
            _hover={{ bg: selectedItem === 'home' ? 'blue.500' : '#f0f0f0' }}
            onClick={() => handleSelectItem('home')}
          >
            <Icon as={FaHome} mr={3} color={selectedItem === 'home' ? 'white' : 'black'} />
            <Text color={selectedItem === 'home' ? 'white' : 'black'}>Home</Text>
          </Link>

          <Link
            p={2}
            h="40px"
            href="#"
            display="flex"
            alignItems="center"
            justifyContent="flex-start"
            w="full"
            bg={selectedItem === 'jobs' ? 'blue.500' : 'transparent'}
            _hover={{ bg: selectedItem === 'jobs' ? 'blue.500' : '#f0f0f0' }}
            onClick={() => handleSelectItem('jobs')}
          >
            <Icon as={FaBriefcase} mr={3} color={selectedItem === 'jobs' ? 'white' : 'black'} />
            <Text color={selectedItem === 'jobs' ? 'white' : 'black'}>Jobs</Text>
          </Link>

          {/* <Link
            p={2}
            h="40px"
            href="#"
            display="flex"
            alignItems="center"
            justifyContent="flex-start"
            w="full"
            bg={selectedItem === 'mySchedule' ? 'blue.500' : 'transparent'}
            _hover={{ bg: selectedItem === 'mySchedule' ? 'blue.500' : '#f0f0f0' }}
            onClick={() => handleSelectItem('mySchedule')}
          >
            <Icon as={FaCalendar} mr={3} color={selectedItem === 'mySchedule' ? 'white' : 'black'} />
            <Text color={selectedItem === 'mySchedule' ? 'white' : 'black'}>My Schedule</Text>
          </Link> */}

          <Link
            p={2}
            h="40px"
            href="#"
            display="flex"
            alignItems="center"
            justifyContent="flex-start"
            w="full"
            bg={selectedItem === 'payments' ? 'blue.500' : 'transparent'}
            _hover={{ bg: selectedItem === 'payments' ? 'blue.500' : '#f0f0f0' }}
            onClick={() => handleSelectItem('payments')}
          >
            <Icon as={FaFileAlt} mr={3} color={selectedItem === 'payments' ? 'white' : 'black'} />
            <Text color={selectedItem === 'payments' ? 'white' : 'black'}>Invoices</Text>
          </Link>

          <Link
            p={2}
            h="40px"
            href="#"
            display="flex"
            alignItems="center"
            justifyContent="flex-start"
            w="full"
            bg={selectedItem === 'earnings' ? 'blue.500' : 'transparent'}
            _hover={{ bg: selectedItem === 'earnings' ? 'blue.500' : '#f0f0f0' }}
            onClick={() => handleSelectItem('earnings')}
          >
            <Icon as={FaChartLine} mr={3} color={selectedItem === 'earnings' ? 'white' : 'black'} />
            <Text color={selectedItem === 'earnings' ? 'white' : 'black'}>Earnings</Text>
          </Link>

          {/* <Link
            p={2}
            h="40px"
            href="#"
            display="flex"
            alignItems="center"
            justifyContent="flex-start"
            w="full"
            bg={selectedItem === 'history' ? 'blue.500' : 'transparent'}
            _hover={{ bg: selectedItem === 'history' ? 'blue.500' : '#f0f0f0' }}
            onClick={() => handleSelectItem('history')}
          >
            <Icon as={FaHistory} mr={3} color={selectedItem === 'history' ? 'white' : 'black'} />
            <Text color={selectedItem === 'history' ? 'white' : 'black'}>History</Text>
          </Link> */}

          {/* My Profile with Collapse Submenu */}
          <Flex direction="column" w="full">
            <Flex
              align="center"
              p={2}
              h="40px"
              cursor="pointer"
              justifyContent="space-between"
              w="full"
              onClick={toggleProfile}
              bg={selectedItem === 'profile' ? 'blue.500' : 'transparent'}
              _hover={{ bg: selectedItem === 'profile' ? 'blue.500' : '#f0f0f0' }}
            >
              <Flex align="center" justifyContent="flex-start">
                <Icon as={FaUser} mr={3} color={selectedItem === 'profile' ? 'white' : 'black'} />
                <Text color={selectedItem === 'profile' ? 'white' : 'black'}>My Profile</Text>
              </Flex>
              {isProfileOpen ? <ChevronUpIcon color={selectedItem === 'profile' ? 'white' : 'black'} /> : <ChevronDownIcon color={selectedItem === 'profile' ? 'white' : 'black'} />}
            </Flex>
            <Collapse in={isProfileOpen} animateOpacity>
              <Box pl={8} py={2}>
                <Link
                  p={2}
                  h="40px"
                  href="#"
                  display="flex"
                  alignItems="center"
                  justifyContent="flex-start"
                  w="full"
                  bg={selectedItem === 'documents' ? 'blue.500' : 'transparent'}
                  _hover={{ bg: selectedItem === 'documents' ? 'blue.500' : '#f0f0f0' }}
                  onClick={() => onSelectProfileSubView('documents')}
                >
                  <Icon as={FaFileAlt} mr={3} color={selectedItem === 'documents' ? 'white' : 'black'} />
                  <Text color={selectedItem === 'documents' ? 'white' : 'black'}>Documents</Text>
                </Link>

                <Link
                  p={2}
                  h="40px"
                  href="#"
                  display="flex"
                  alignItems="center"
                  justifyContent="flex-start"
                  w="full"
                  bg={selectedItem === 'privacy' ? 'blue.500' : 'transparent'}
                  _hover={{ bg: selectedItem === 'privacy' ? 'blue.500' : '#f0f0f0' }}
                  onClick={() => {
                    onSelectItem('profile');
                    onSelectProfileSubView('privacy');
                  }}
                >
                  <Icon as={FaLock} mr={3} color={selectedItem === 'privacy' ? 'white' : 'black'} />
                  <Text color={selectedItem === 'privacy' ? 'white' : 'black'}>Privacy</Text>
                </Link>
              </Box>
            </Collapse>
          </Flex>
        </Flex>
      </VStack>

      <VStack spacing={4} align="flex-start" p={4} mt="auto">
        <Link
          p={2}
          h="40px"
          href="#"
          display="flex"
          alignItems="center"
          justifyContent="flex-start"
          w="full"
          bg={selectedItem === 'settings' ? 'blue.500' : 'transparent'}
          _hover={{ bg: selectedItem === 'settings' ? 'blue.500' : '#f0f0f0' }}
          onClick={() => handleSelectItem('settings')}
        >
          <Icon as={FaCog} mr={3} color={selectedItem === 'settings' ? 'white' : 'black'} />
          <Text color={selectedItem === 'settings' ? 'white' : 'black'}>Settings</Text>
        </Link>
        <Link
          p={2}
          h="40px"
          href="#"
          display="flex"
          alignItems="center"
          justifyContent="flex-start"
          w="full"
          bg={selectedItem === 'help' ? 'blue.500' : 'transparent'}
          _hover={{ bg: selectedItem === 'help' ? 'blue.500' : '#f0f0f0' }}
          onClick={() => handleSelectItem('help')}
        >
          <Icon as={FaQuestionCircle} mr={3} color={selectedItem === 'help' ? 'white' : 'black'} />
          <Text color={selectedItem === 'help' ? 'white' : 'black'}>Get Help</Text>
        </Link>
      </VStack>
    </Flex>
  );
};

export default Sidebar;